import { trackPageView } from '@/common/analytics/analytics'
import { exposeI18nGlobals } from '@/common/i18n/i18n'

let lastPath = ''

export function setupAnalyticsGlobals(): void {
  exposeI18nGlobals()
}

export function onRouteAnalytics(pathname: string): void {
  if (pathname === lastPath) {
    return
  }
  lastPath = pathname
  trackPageView(pathname)
}
